const theme = {
  serif: `"Source Serif Pro", serif`,
  sansSerif: `"Roboto", sans-serif`,
  jumpColor: '#1abbd4',
  vocabColor: '#91de4b',
  vocabTipColor: '#69c00d',
  trickyColor: '#6bbdca',
  sicColor: '#ffa100',
  tooltipZIndex: 1000,
  transportZIndex: 2000,
};
export default theme;
